module.exports = __webpack_public_path__ + "static/finelite_hero_logo-1df601be77597df5096d737fdcbb6167.png";